import i18n from '@/utils/i18n'
import { submissionStatus } from '@/utils/locale'

const statusClsMap = Object.freeze({
  DRAFT: 'draft-status',
  ACCEPT: 'accepted-status',
  REJECTED: 'rejected-status',
  UNACCEPT: 'unaccepted-status',
})

export function isSubmUnaccepted (submission = {}, vendorView = false) {
  const [, status] = getSubmStatusLabel(submission, vendorView)
  return status === statusClsMap.UNACCEPT
}

/**
 * @returns {[string, typeof statusClsMap[keyof typeof statusClsMap] | '']}
 */
export function getSubmStatusLabel (submission = {}, vendorView = false) {
  if (submissionStatus.OPEN === submission.status) {
    return [vendorView ? 'SUBMITTED' : '', vendorView ? statusClsMap[submission.status] : '']
  }
  const actionHistory = submission.actionHistory || []
  if (!actionHistory || actionHistory.length === 0) {
    return [submission.status, statusClsMap[submission.status]]
  }
  const lastApproval = actionHistory[0] || {}
  if (!lastApproval.approver) {
    return [vendorView ? submission.status : '', vendorView ? statusClsMap[submission.status] : '']
  }

  const isUnaccepted = lastApproval.actionType === i18n.t('action.unaccept').toUpperCase()
  let approvalLable = submission.status.toUpperCase()
  if (approvalLable === 'REJECTED' && isUnaccepted) {
    approvalLable = i18n.t('action.unaccept').toUpperCase()
  } else if (approvalLable === 'APPR') {
    approvalLable = i18n.t('action.accept').toUpperCase()
  }

  return [approvalLable, statusClsMap[approvalLable]]
}
